module.exports = __webpack_public_path__ + "img/map-zimbabwe.0828a08d.png";